export default "__VITE_ASSET__PNSmYMS4__"